module.exports = __webpack_public_path__ + "img/stock7.19bc071d.png";